module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "forms-ai-lib": "static-1.3489"
    },
    "depPathPrefixes": {
      "forms-ai-lib": "/forms-ai-lib/static-1.3489"
    },
    "project": "forms-ai-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};